import React from "react";
import { Button, Modal } from "react-bootstrap";
import { Trans } from "react-i18next";
import "../styles/components/UserExistPopUp.scss";

interface UserExistPopUpType {
  show: boolean;
  handelClose: () => void;
  title_key: string;
  body_key: string;
  secondaryButtonTitle_key: string;
}

const UserExistPopUp = ({
  show,
  handelClose,
  title_key,
  body_key,
  secondaryButtonTitle_key,
}: UserExistPopUpType) => {
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          handelClose();
        }}
        centered={true}
        className="userModelExistPopUp"
      >
        <Modal.Header className="userModelHeaderExistPopUp">
          <Modal.Title
            data-testid="popupTestTitle"
            className="existPopUpTitleContainer"
          >
            <img
              src="/icons/alert-icon-patient.svg"
              className="patientDimensions"
            />
            <div className="userModelHeaderExistPopUpTextTitle">
              <Trans i18nKey={title_key?.toLowerCase()} />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="userModelBodyExistPopUp">
          <Trans i18nKey={body_key?.toLowerCase()} />
        </Modal.Body>
        <Modal.Footer className="userFooterExistPopUp">
          <Button
            variant="secondary"
            data-testid="popupSecondaryText"
            onClick={() => {
              handelClose();
            }}
          >
            <Trans i18nKey={secondaryButtonTitle_key?.toLowerCase()} />
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UserExistPopUp;
